import { Box, Typography } from "@mui/material";

export type LastWeekDetailCardProps = {
  title: string;
  subTitle: string;
};

export const LastWeekDetailCard = (props: LastWeekDetailCardProps) => {
  return (
    <Box
      sx={{
        borderRadius: ".75rem",
        flex: "1 1 0",
        border: "1px solid var(--team-app-card-accent-bg)",
        boxShadow: "0 4px 0 0 var(--team-app-card-accent-bg)",
        paddingY: "1rem",
        paddingX: "1.5rem",
      }}
    >
      <Box>
        <Typography
          variant="cardTitle"
          sx={{
            fontWeight: 700,
          }}
        >
          {props.title}
        </Typography>
      </Box>
      <Box>
        <Typography variant="cardSubtitle">{props.subTitle}</Typography>
      </Box>
    </Box>
  );
};
